import API from "../../../../../../global/api";

//GET ALL CALL

export const requestAllAssetDebitData = (data) => {
    return {
      type: "REQUEST_ALL_ASSET_DEBIT_DATA",
    };
  };
  export const successAllAssetDebitData = (data) => {
    return {
      type: "SUCCESS_ALL_ASSET_DEBIT_DATA",
      payload: data,
    };
  };
  export const errorAllAssetDebitData = () => {
    return {
      type: "ERROR_ALL_ASSET_DEBIT_DATA"
    };
  };
  
  export const allAssetDebitData = (data) => {
    return (dispatch) => {
      dispatch(requestAllAssetDebitData(data))
      API.post(`/assetDebit/get-all-form-data`,data).then((res) => {
         let data1 = [];
         data1 = res.data;
        dispatch(successAllAssetDebitData(data1));
      }).catch(err => {
        dispatch(errorAllAssetDebitData());
      })
    };
  };



//POST CALL

export const requestAssetDebitData = (data) => {
    return {
      type: "REQUEST_ASSET_DEBIT_DATA",
    };
  };
  export const successAssetDebitData = (data) => {
    return {
      type: "SUCCESS_ASSET_DEBIT_DATA",
      payload: data,
    };
  };
  export const errorAssetDebitData = (data) => {
    return {
      type: "ERROR_ASSET_DEBIT_DATA",
      payload: data,
    };
  };
  
  export const postAssetDebitData = (data) => {
    return (dispatch) => {
      API.post(`/assetDebit/postAssetDebitData`, data).then((res) => {
        dispatch(successAssetDebitData(data));
      });
    };
  };

//EMPLOYEMENT_DETAILS

export const requestEmployementDetails = (data) => {
    return {
      type: "REQUEST_EMPLOYEMENT_DETAILS",
    };
  };
  export const successEmployementDetails = (data) => {
    return {
      type: "SUCCESS_EMPLOYEMENT_DETAILS",
      payload: data,
    };
  };
  export const errorEmployementDetails = (data) => {
    return {
      type: "ERROR_EMPLOYEMENT_DETAILS",
      payload: data,
    };
  };
  
  export const employementDetails = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/employementDetails`,data).then((res) => {
        dispatch(successEmployementDetails(data));
      });
    };
  };

  //AGE AND EDUCATION

  export const requestAgeEducation = (data) => {
    return {
      type: "REQUEST_AGE_EDUCATION",
    };
  };
  export const successAgeEducation = (data) => {
    return {
      type: "SUCCESS_AGE_EDUCATION",
      payload: data,
    };
  };
  export const errorAgeEducation = (data) => {
    return {
      type: "ERROR_AGE_EDUCATION",
      payload: data,
    };
  };
  
  export const ageEducation = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/ageEducation`,data).then((res) => {
        dispatch(successAgeEducation(data));
      });
    };
  };


  //TAX INFORMATON

  export const requestTaxInformation = (data) => {
    return {
      type: "REQUEST_TAX_INFORMATION",
    };
  };
  export const successTaxInformation = (data) => {
    return {
      type: "SUCCESS_TAX_INFORMATION",
      payload: data,
    };
  };
  export const errorTaxInformation = (data) => {
    return {
      type: "ERROR_TAX_INFORMATION",
      payload: data,
    };
  };
  
  export const taxInformation = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/taxInformation`,data).then((res) => {
        dispatch(successTaxInformation(data));
      });
    };
  };

  //OTHER PARTY INCOME
  
  export const requestOtherPartyIncome = (data) => {
    return {
      type: "REQUEST_OTHER_PARTY_INCOME",
    };
  };
  export const successOtherPartyIncome = (data) => {
    return {
      type: "SUCCESS_OTHER_PARTY_INCOME",
      payload: data,
    };
  };
  export const errorOtherPartyIncome = (data) => {
    return {
      type: "ERROR_OTHER_PARTY_INCOME",
      payload: data,
    };
  };
  
  export const otherPartyIncome = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/otherPartyIncome`, data).then((res) => {
        dispatch(successOtherPartyIncome(data));
      });
    };
  };

  //INCOME
  
  export const requestIncome = (data) => {
    return {
      type: "REQUEST_INCOME",
    };
  };
  export const successIncome = (data) => {
    return {
      type: "SUCCESS_INCOME",
      payload: data,
    };
  };
  export const errorIncome = (data) => {
    return {
      type: "ERROR_INCOME",
      payload: data,
    };
  };
  
  export const income = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/income`,data ).then((res) => {
        dispatch(successIncome(data));
      });
    };
  };

//Invest Income
 
export const requestInvestIncome = (data) => {
    return {
      type: "REQUEST_INVEST_INCOME",
    };
  };
  export const successInvestIncome = (data) => {
    return {
      type: "SUCCESS_INVEST_INCOME",
      payload: data,
    };
  };
  export const errorInvestIncome = (data) => {
    return {
      type: "ERROR_INVEST_INCOME",
      payload: data,
    };
  };
  
  export const investIncome = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/investIncome`,data ).then((res) => {
        dispatch(successInvestIncome(data));
      });
    };
  };

  //Additional Income
  
export const requestAdditionalIncome = (data) => {
    return {
      type: "REQUEST_ADDITIONAL_INCOME",
    };
  };
  export const successAdditionalIncome = (data) => {
    return {
      type: "SUCCESS_ADDITIONAL_INCOME",
      payload: data,
    };
  };
  export const errorAdditionalIncome = (data) => {
    return {
      type: "ERROR_ADDITIONAL_INCOME",
      payload: data,
    };
  };
  
  export const additionalIncome = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/additionalIncome`,data ).then((res) => {
        dispatch(successAdditionalIncome(data));
      });
    };
  };

  //Self Employeed Income

   
export const requestSelfEmployeedIncome = (data) => {
    return {
      type: "REQUEST_SELF_EMPLOYEED_INCOME",
    };
  };
  export const successSelfEmployeedIncome = (data) => {
    return {
      type: "SUCCESS_SELF_EMPLOYEED_INCOME",
      payload: data,
    };
  };
  export const errorSelfEmployeedIncome = (data) => {
    return {
      type: "ERROR_SELF_EMPLOYEED_INCOME",
      payload: data,
    };
  };
  
  export const selfEmployeedIncome = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/selfEmployeedIncome`,data ).then((res) => {
        dispatch(successSelfEmployeedIncome(data));
      });
    };
  };

  //Change In Income
  
   
export const requestChangeInIncome = (data) => {
    return {
      type: "REQUEST_CHANGE_IN_INCOME",
    };
  };
  export const successChangeInIncome = (data) => {
    return {
      type: "SUCCESS_CHANGE_IN_INCOME",
      payload: data,
    };
  };
  export const errorChangeInIncome = (data) => {
    return {
      type: "ERROR_CHANGE_IN_INCOME",
      payload: data,
    };
  };
  
  export const changeInIncome = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/changeInIncome`,data ).then((res) => {
        dispatch(successChangeInIncome(data));
      });
    };
  };


  //Deductions
  export const requestDeductions = (data) => {
    return {
      type: "REQUEST_DEDUCTIONS",
    };
  };
  export const successDeductions = (data) => {
    return {
      type: "SUCCESS_DEDUCTIONS",
      payload: data,
    };
  };
  export const errorDeductions = (data) => {
    return {
      type: "ERROR_DEDUCTIONS",
      payload: data,
    };
  };
  
  export const deductions = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/deductions`,data ).then((res) => {
        dispatch(successDeductions(data));
      });
    };
  };

  //Asset

  export const requestAsset = (data) => {
    return {
      type: "REQUEST_ASSET",
    };
  };
  export const successAsset = (data) => {
    return {
      type: "SUCCESS_ASSET",
      payload: data,
    };
  };
  export const errorAsset = (data) => {
    return {
      type: "ERROR_ASSET",
      payload: data,
    };
  };
  
  export const asset = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/asset`,data ).then((res) => {
        dispatch(successAsset(data));
      });
    };
  };

//Average Monthallay Expense


export const requestAverageMonthallyExpense = (data) => {
    return {
      type: "REQUEST_AVERAGE_MONTHALLY_EXPENSE",
    };
  };
  export const successAverageMonthallyExpense = (data) => {
    return {
      type: "SUCCESS_AVERAGE_MONTHALLY_EXPENSE",
      payload: data,
    };
  };
  export const errorAverageMonthallyExpense = (data) => {
    return {
      type: "ERROR_AVERAGE_MONTHALLY_EXPENSE",
      payload: data,
    };
  };
  
  export const averageMonthallyExpenset = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/averageMonthallyExpenset`,data ).then((res) => {
        dispatch(successAverageMonthallyExpense(data));
      });
    };
  };

  //Attorney Fee

  export const requestAttorneyFee = (data) => {
    return {
      type: "REQUEST_ATTORNEY_FEE",
    };
  };
  export const successAttorneyFee = (data) => {
    return {
      type: "SUCCESS_ATTORNEY_FEE",
      payload: data,
    };
  };
  export const errorAttorneyFee = (data) => {
    return {
      type: "ERROR_ATTORNEY_FEE",
      payload: data,
    };
  };
  
  export const attorneyFee = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/attorneyFee`,data ).then((res) => {
        dispatch(successAttorneyFee(data));
      });
    };
  };

  //NUMBER OF CHILDREN

export const requestNumberOfChildren = (data) => {
    return {
      type: "REQUEST_NUMBER_OF_CHILDREN",
    };
  };
  export const successNumberOfChildren = (data) => {
    return {
      type: "SUCCESS_NUMBER_OF_CHILDREN",
      payload: data,
    };
  };
  export const errorNumberOfChildren = (data) => {
    return {
      type: "ERROR_NUMBER_OF_CHILDREN",
      payload: data,
    };
  };
  
  export const numberOfChildren = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/numberOfChildren`,data ).then((res) => {
        dispatch(successNumberOfChildren(data));
      });
    };
  };

  //CHILD HEALTH EXPENSES

export const requestChildHealthExpenses = (data) => {
    return {
      type: "REQUEST_CHILD_HEALTH_EXPENSES",
    };
  };
  export const successChildHealthExpenses = (data) => {
    return {
      type: "SUCCESS_CHILD_HEALTH_EXPENSES",
      payload: data,
    };
  };
  export const errorChildHealthExpenses = (data) => {
    return {
      type: "ERROR_CHILD_HEALTH_EXPENSES",
      payload: data,
    };
  };
  
  export const childHealthExpenses = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/childHealthExpenses`,data ).then((res) => {
        dispatch(successChildHealthExpenses(data));
      });
    };
  };

  //Child Additional Expense

  
export const requestChildAdditionalExpenses = (data) => {
    return {
      type: "REQUEST_CHILD_ADDITIONAL_EXPENSES",
    };
  };
  export const successChildAdditionalExpenses = (data) => {
    return {
      type: "SUCCESS_CHILD_ADDITIONAL_EXPENSES",
      payload: data,
    };
  };
  export const errorChildAdditionalExpenses = (data) => {
    return {
      type: "ERROR_CHILD_ADDITIONAL_EXPENSES",
      payload: data,
    };
  };
  
  export const childAdditionalExpenses = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/childAdditionalExpenses`,data ).then((res) => {
        dispatch(successChildAdditionalExpenses(data));
      });
    };
  };

  //Special hardship
  
  export const requestSpecialHardship = (data) => {
    return {
      type: "REQUEST_SPECIAL_HARDSHIP",
    };
  };
  export const successSpecialHardship = (data) => {
    return {
      type: "SUCCESS_SPECIAL_HARDSHIP",
      payload: data,
    };
  };
  export const errorSpecialHardship = (data) => {
    return {
      type: "ERROR_SPECIAL_HARDSHIP",
      payload: data,
    };
  };
  
  export const specialHardship = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/specialHardship`,data ).then((res) => {
        dispatch(successSpecialHardship(data));
      });
    };
  };

  //Other Information

  export const requestOtherInformation = (data) => {
    return {
      type: "REQUEST_OTHER_INFORMATION",
    };
  };
  export const successOtherInformation = (data) => {
    return {
      type: "SUCCESS_OTHER_INFORMATION",
      payload: data,
    };
  };
  export const errorOtherInformation = (data) => {
    return {
      type: "ERROR_OTHER_INFORMATION",
      payload: data,
    };
  };
  
  export const otherInformation = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/otherInformation`,data ).then((res) => {
        dispatch(successOtherInformation(data));
      });
    };
  };


  export const requestPeopleLive = (data) => {
    return {
      type: "REQUEST_PEOPLE_LIVE",
    };
  };
  export const successPeopleLive = (data) => {
    return {
      type: "SUCCESS_PEOPLE_LIVE",
      payload: data,
    };
  };
  export const errorPeopleLive = (data) => {
    return {
      type: "ERROR_PEOPLE_LIVE",
      payload: data,
    };
  };
  
  export const peopleLiveCall = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/add-and-update-live-with-me`,data).then((res) => {
        dispatch(successPeopleLive(res.data));
      });
    };
  };




  export const requestInstallmentPayments = (data) => {
    return {
      type: "REQUEST_INSTALLMENT_PAYMENTS",
    };
  };
  export const successInstallmentPayments = (data) => {
    return {
      type: "SUCCESS_INSTALLMENT_PAYMENTS",
      payload: data,
    };
  };
  export const errorInstallmentPayments = (data) => {
    return {
      type: "ERROR_INSTALLMENT_PAYMENTS",
      payload: data,
    };
  };
  
  export const  installmentPaymentsCall = (data) => {
    return (dispatch) => {
      API.put(`/assetDebit/add-and-update-installments`,data).then((res) => {
        dispatch(successInstallmentPayments(res.data));
      });
    };
  };



  export const requestDeletePeopleLive = (data) => {
    return {
      type: "REQUEST_DELETE_PEOPLE_LIVE",
    };
  };
  export const successDeletePeopleLive = (data) => {
    return {
      type: "SUCCESS_DELETE_PEOPLE_LIVE",
      payload: data,
    };
  };
  export const errorDeletePeopleLive = (data) => {
    return {
      type: "ERROR_DELETE_PEOPLE_LIVE",
      payload: data,
    };
  };
  
  export const  deletePeopleLiveCall = (data) => {
    return (dispatch) => {
      API.post(`/assetDebit/delete-live-with-me`,data).then((res) => {
        dispatch(successDeletePeopleLive(res.data));
      });
    };
  };


  // delete installments

  export const requestDeleteInstallment = (data) => {
    return {
      type: "REQUEST_DELETE_INSTALLMENT",
    };
  };
  export const successDeleteInstallment = (data) => {
    return {
      type: "SUCCESS_DELETE_INSTALLMENT",
      payload: data,
    };
  };
  export const errorDeleteInstallment = (data) => {
    return {
      type: "ERROR_DELETE_INSTALLMENT",
      payload: data,
    };
  };
  
  export const  deleteInstallmentCall = (data) => {
    return (dispatch) => {
      API.post(`/assetDebit/delete-installments-data`,data).then((res) => {
        dispatch(successDeleteInstallment(res.data));
      });
    };
  };
